import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';

@Component({
  selector: 'wsd-organization-detail-information',
  templateUrl: './organization-detail-information.component.html',
  styleUrls: ['./organization-detail-information.component.css']
})
export class OrganizationDetailInformationComponent {

  @Input()
  parentForm: UntypedFormGroup;

  languageFilters = {
    global: ['English', 'French'],
    working: ['Arabic', 'English', 'French', 'Russian', 'Spanish']
  };

  constructor() { }

}
